import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const GlobalBlocker = ({ setFrozen }) => {
    const [isOffline, setIsOffline] = useState(!navigator.onLine);

    useEffect(() => {
        // Prevent back/forward navigation
        window.history.pushState(null, "", window.location.href);
        const handlePopState = () => {
            window.history.pushState(null, "", window.location.href);
        };
        window.addEventListener("popstate", handlePopState);

        const handleOnline = () => {
            setIsOffline(false);
            setFrozen(false); // Unfreeze app
        };

        const handleOffline = () => {
            setIsOffline(true);
        };

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("popstate", handlePopState);
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, [setFrozen]);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.85)",
                color: "white",
                zIndex: 9999,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "1.5rem",
                padding: "2rem",
                textAlign: "center",
                backdropFilter: "blur(8px)",
                WebkitBackdropFilter: "blur(8px)",
            }}
        >
            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 100, damping: 10 }} style={{ fontSize: "5rem", marginBottom: "1rem" }}>
                {isOffline ? "☹" : "🚧"}
            </motion.div>

            <motion.div initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.3 }} style={{ maxWidth: "600px" }}>
                {isOffline ? "No internet connection detected." : "The application is currently undergoing maintenance. Please try again later."}
            </motion.div>

            <div style={{ marginTop: "2rem", fontSize: "1.2rem", opacity: 0.7, display: "flex", gap: "0.2rem" }}>
                <span>{isOffline ? "Please check your connection" : "Trying to reconnect"}</span>
                <motion.span animate={{ opacity: [0, 1, 0] }} transition={{ repeat: Infinity, duration: 2, delay: 0 }}>
                    .
                </motion.span>
                <motion.span animate={{ opacity: [0, 1, 0] }} transition={{ repeat: Infinity, duration: 2, delay: 0.2 }}>
                    .
                </motion.span>
                <motion.span animate={{ opacity: [0, 1, 0] }} transition={{ repeat: Infinity, duration: 2, delay: 0.4 }}>
                    .
                </motion.span>
            </div>
        </motion.div>
    );
};

export default GlobalBlocker;
